import React, { useRef, HTMLAttributes, useEffect, useState } from 'react';
import { styled } from '@mui/system';
import Hint from '@/components/Hint';

const Caption = styled('span')((props: { overflows: boolean }) => ({
  cursor: 'default',
  textOverflow: 'clip',
  overflowX: 'hidden',
  overflowY: 'hidden',
  whiteSpace: 'nowrap',
  display: 'block',
  //flexGrow: 1,
  //minWidth: 0,
  ...(props.overflows ? {
    position: 'relative',
    '&::after': {
      content: '"\u2026"',
      position: 'absolute',
      right: 0,
      backgroundColor: '#FFFFFF',
    }
  } : {}),
}));

const Content = styled('p')({
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '16px',
  letterSpacing: '0em',
  textAlign: 'left',
  margin: 0,
});

const canvas = document.createElement("canvas");
const context = canvas.getContext("2d")!;
if (!context) {
  throw new Error("2D context not supported in this browser.");
}

/*
function measureTextWidth(text: string, font: string): number {
  context.font = font;
  return context.measureText(text).width;
}

function truncateText(text: string, width: number, font: string): string {
  const ellipsisWidth = measureTextWidth('\u2026', font);
  let left = 0;
  let right = text.length;
  let bestFit = "";
  while (left <= right) {
    const mid = Math.floor((left + right) / 2);
    const candidate = text.slice(0, mid);
    const w = measureTextWidth(candidate, font) + ellipsisWidth;

    if (w <= width) {
      bestFit = candidate;
      left = mid + 1;
    } else {
      right = mid - 1;
    }
  }
  return bestFit + '\u2026';
}
*/

const OverflowObserver = new ResizeObserver((entries) => {
  for (const entry of entries) {
    if (resizeHandlers.has(entry.target)) {
      resizeHandlers.get(entry.target)!();
    }
  }
});
const resizeHandlers = new Map<Element, () => void>();

export default function ({ children, ...props }: HTMLAttributes<HTMLSpanElement>) {
  const element = useRef<HTMLElement>(null);

  const [w, setW] = useState<number>(0);
  //const [displayed, setDisplayed] = useState<string>(children);
  const [overflows, setOverflows] = useState(false);

  useEffect(() => {
    if (element.current) {
      const el = element.current;

      resizeHandlers.set(el, () => {
        setW(el.offsetWidth);

        setOverflows(el.clientWidth < el.scrollWidth);
        /*
        const font = window.getComputedStyle(el).font;
        if (el.clientWidth < measureTextWidth(children, font)) {
          const currTextWidth = measureTextWidth(el.innerText, font);
          if (Math.abs(currTextWidth - el.clientWidth) > 1) {
            setDisplayed(truncateText(children, el.clientWidth, font))
          }
        } else {
          setDisplayed(children);
        }
        */
      });

      OverflowObserver.observe(el);
      return () => {
        resizeHandlers.delete(el);
        OverflowObserver.unobserve(el)
      };
    }
  }, [ element.current, children ]);

  return (<>
    <Caption
      {...props}
      ref={element}
      overflows={overflows}
    >
      {children/* displayed */}
    </Caption>
    <Hint
      anchor={element}
      disabled={!overflows/*displayed === children*/}
      delay={350}
      closeDelay={200}
      placement='bottom-start'
      flipFallbackPlacements={[
        'bottom',
        'bottom-end',
        'top-start',
        'top',
        'top-end'
      ]}
    >
      <Content style={{
        minWidth: w,
        maxWidth: w * 1.5 || undefined,
      }}>{children}</Content>
    </Hint>
  </>);
}